import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const STATUS = {
  sent: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300",
  queued: "border-amber-500/30 bg-amber-500/10 text-amber-300",
  failed: "border-rose-500/30 bg-rose-500/10 text-rose-300",
  logged_only: "border-slate-500/30 bg-slate-500/10 text-slate-300",
};

export default function AdminEmailLogs() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  const load = () => api.get("/admin/email-logs").then((r) => setLogs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const shown = logs.filter((l) => !q || `${l.to} ${l.subject} ${l.template_key} ${l.from}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <p className="eyebrow">Communications</p>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <h1 className="font-serif text-3xl tracking-tight">Email Log</h1>
        <button onClick={load} data-testid="email-log-refresh" className="ml-auto flex items-center gap-1.5 rounded-full border border-white/10 px-4 py-2 font-sans text-xs text-[#94A3B8] hover:text-gold"><RefreshCw size={13} /> Refresh</button>
      </div>
      <p className="mt-2 font-sans text-sm text-[#94A3B8]">Every email the system has sent, with its delivery status (latest 500).</p>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search recipient, subject or template…" data-testid="email-log-search" className="mt-6 w-full max-w-md rounded-md border border-white/10 bg-[#0A0D14] px-3 py-2 font-sans text-sm focus:border-gold focus:outline-none" />
      <div className="mt-6 overflow-x-auto rounded-lg border border-white/5">
        <table className="w-full min-w-[900px] text-left">
          <thead className="bg-[#18202E]">
            <tr className="font-mono text-[10px] uppercase tracking-widest text-[#94A3B8]">{["Time", "To", "From", "Template", "Subject", "Status"].map((h) => <th key={h} className="px-4 py-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {shown.map((l) => (
              <tr key={l.id} onClick={() => setOpen(l)} data-testid={`email-log-row-${l.id}`} className="cursor-pointer border-t border-white/5 hover:bg-white/5">
                <td className="px-4 py-3 font-sans text-xs text-[#94A3B8]">{new Date(l.created_at).toLocaleString("en-SG", { dateStyle: "medium", timeStyle: "short" })}</td>
                <td className="px-4 py-3 font-sans text-sm">{l.to}</td>
                <td className="px-4 py-3 font-sans text-xs text-[#94A3B8]">{l.from}</td>
                <td className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-gold">{l.template_key}</td>
                <td className="px-4 py-3 font-sans text-sm text-[#94A3B8]">{l.subject}</td>
                <td className="px-4 py-3"><span className={`rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest ${STATUS[l.status] || STATUS.queued}`}>{l.status.replace("_", " ")}</span></td>
              </tr>
            ))}
            {shown.length === 0 && <tr><td colSpan={6} className="px-5 py-12 text-center font-sans text-sm text-[#94A3B8]">No emails yet.</td></tr>}
          </tbody>
        </table>
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto border-white/10 bg-[#121722] text-[#F1F5F9]">
          <DialogHeader>
            <DialogTitle className="font-serif text-xl">{open?.subject}</DialogTitle>
            <DialogDescription className="text-[#94A3B8]">From {open?.from} → {open?.to} · {open?.status}{open?.error ? ` · ${open.error}` : ""}</DialogDescription>
          </DialogHeader>
          {open && <div className="rounded-md bg-white p-5 font-serif text-sm text-black" dangerouslySetInnerHTML={{ __html: open.body }} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
